import { formatDate } from "@fullcalendar/core";

export const findScheduleByDate = (date, schedules) => {
  return schedules?.find((el) => {
    const eDate = formatDate(el.start, { timeZone: "local" });
    const sDate = formatDate(date, { timeZone: "local" });
    return eDate === sDate;
  });
};

export const getLocalDate = (date) => {
  return formatDate(date, { timeZone: "local" });
};
